export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'US',
  'merchantReturnLink': 'https://www.timberland.com/en-us/free-return-policy',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
